// 运营平台请求
import request from '../utils/oms_request'
export function createShareRelation (data) {
  return request({
    url: '/shareRelation/create',
    method: 'POST',
    data
  })
}
export function updateShareRelation (data) {
  return request({
    url: '/shareRelation/update',
    method: 'PUT',
    data
  })
}
export function deleteShareRelation (shareRelationId) {
  return request({
    url: '/shareRelation/delete',
    method: 'DELETE',
    params: {
      shareRelationId: shareRelationId
    }
  })
}
export function getShareRelation (shareRelationId) {
  return request({
    url: '/shareRelation/get',
    method: 'GET',
    params: {
      shareRelationId: shareRelationId
    }
  })
}
export function searchShareRelation (data) {
  return request({
    url: '/shareRelation/search',
    method: 'POST',
    data: data
  })
}
export function listShareRelation (tenantId) {
  return request({
    url: '/shareRelation/get',
    method: 'GET',
    params: {
      tenantId: tenantId
    }
  })
}
export function createIndustry (data) {
  return request({
    url: '/industry/create',
    method: 'POST',
    data
  })
}
export function updateIndustry (data) {
  return request({
    url: '/industry/update',
    method: 'PUT',
    data
  })
}
export function deleteIndustry (industryId) {
  return request({
    url: '/industry/delete',
    method: 'DELETE',
    params: {
      industryId: industryId
    }
  })
}
export function disableIndustry (industryId) {
  return request({
    url: '/industry/disable',
    method: 'PUT',
    params: {
      industryId: industryId
    }
  })
}
export function enableIndustry (industryId) {
  return request({
    url: '/industry/enable',
    method: 'PUT',
    params: {
      industryId: industryId
    }
  })
}
export function getIndustry (industryId) {
  return request({
    url: '/industry/get',
    method: 'GET',
    params: {
      industryId: industryId
    }
  })
}
export function getIndustryChildren (data) {
  return request({
    url: '/industry/children',
    method: 'GET',
    params: {
      parentIndustryId: data
    }
  })
}
export function querySchemeById (schemeId) {
  return request({
    url: '/scheme/findSchemeById',
    method: 'GET',
    params: {
      schemeId: schemeId
    }
  })
}
export function updateSchemeState (schemeId, updateState, schemeType, schemeState) {
  return request({
    url: '/scheme/updateSchemeState',
    method: 'GET',
    params: {
      schemeId: schemeId,
      updateState: updateState,
      schemeType: schemeType,
      schemeState: schemeState
    }
  })
}

/**
 *查询公共参数
 * @param data
 */
export function queryCommonConfParam (data) {
  return request({
    url: 'confParam/getOptions',
    method: 'GET',
    params: {
      paramKey: data
    }
  })
}
export function queryParams (parentParamId) {
  return request({
    url: '/confParam/children',
    method: 'GET',
    params: {
      parentParamId: parentParamId
    }
  })
}
export function createParam (param) {
  return request({
    url: '/confParam/create',
    method: 'POST',
    data: param
  })
}
export function createParamOption (param) {
  return request({
    url: '/confParam/createOption',
    method: 'POST',
    data: param
  })
}
export function deleteParam (paramId) {
  return request({
    url: '/confParam/delete',
    method: 'DELETE',
    params: {
      paramId: paramId
    }
  })
}
export function deleteParamOption (optionId) {
  return request({
    url: '/confParam/deleteOption',
    method: 'DELETE',
    params: {
      optionId: optionId
    }
  })
}
export function updateParam (data) {
  return request({
    url: '/confParam/update',
    method: 'PUT',
    data: data
  })
}
export function getOptions (paramKey) {
  return request({
    url: '/confParam/getOptions',
    method: 'GET',
    params: {
      paramKey: paramKey
    }
  })
}
export function updateOption (data) {
  return request({
    url: '/confParam/updateOption',
    method: 'PUT',
    data: data
  })
}
export function moveOptionDown (optionId) {
  return request({
    url: '/confParam/moveOptionDown',
    method: 'PUT',
    params: {
      optionId: optionId
    }
  })
}
export function moveOptionUp (optionId) {
  return request({
    url: '/confParam/moveOptionUp',
    method: 'PUT',
    params: {
      optionId: optionId
    }
  })
}
/**
 *查询所有媒体位
 */
export function allMediaList (data) {
  return request({
    url: 'platformMedia/search',
    method: 'POST',
    data: data
  })
}
/**
 *统计所有媒体位
 */
export function countMedia (data) {
  return request({
    url: 'platformMedia/count',
    method: 'POST',
    data: data
  })
}

export function searchPlatformManagement (data) {
  return request({
    url: '/platformManagementData/search',
    method: 'POST',
    data: data
  })
}

export function getTableHeadData (data) {
  return request({
    url: '/platformManagementData/getTableHeadData',
    method: 'POST',
    data: data
  })
}
/**
 *  租户查询
 * @param data
 * @returns {AxiosPromise}
 */
export function tenantSearch (data) {
  return request({
    url: '/tenant/search',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/oms.js